import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'gatsby';
import '../sass/header.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { buildUrl, useCcParam } from '../utils/navigation';

const Header = () => {
  const ccParam = useCcParam();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu when clicking on overlay (mobile only)
  const handleOverlayClick = () => {
    if (isMobile) {
      closeMenu();
    }
  };

  // Close menu when clicking on menu links
  const handleMenuLinkClick = () => {
    closeMenu();
  };

  // Check if device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  // Close menu on escape key and click outside
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeMenu();
      }
    };

    const handleClickOutside = (event: MouseEvent) => {
      if (isMenuOpen && !isMobile && headerRef.current && !headerRef.current.contains(event.target as Node)) {
        closeMenu();
      }
    };

    if (isMenuOpen) {
      document.addEventListener('keydown', handleEscapeKey);
      document.addEventListener('mousedown', handleClickOutside);
      // Prevent body scroll when menu is open on mobile
      if (isMobile) {
        document.body.style.overflow = 'hidden';
      }
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen, isMobile]);

  return (
    <div className="site-header" ref={headerRef}>
      <div className="site-header__logo-section">
        <Link to={buildUrl('/', ccParam)} className="site-header__logo-link">
          <StaticImage 
            src="../images/logitech-logo.png" 
            alt="Logitech" 
            className="site-header__logo"
          />
        </Link>
      </div>
      
      <button 
        className={`site-header__menu-toggle ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={isMenuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`site-header__menu ${isMenuOpen ? 'active' : ''}`}>
        <nav>
          <ul>
            <li><Link to={buildUrl('/#datos-clave', ccParam)} onClick={handleMenuLinkClick}>Datos clave</Link></li>
            <li><Link to={buildUrl('/#setups', ccParam)} onClick={handleMenuLinkClick}>Setups recomendados</Link></li>
            <li><Link to={buildUrl('/#mi-asistente-ergo', ccParam)} onClick={handleMenuLinkClick}>Configuración ergo</Link></li>
            <li><Link to={buildUrl('/#embajador', ccParam)} onClick={handleMenuLinkClick}>La voz del experto</Link></li>
            <li><Link to={buildUrl('/#testimonios', ccParam)} onClick={handleMenuLinkClick}>Testimonios ergo</Link></li>
            <li><Link to={buildUrl('/#ergo-lab', ccParam)} onClick={handleMenuLinkClick}>Ergo Lab</Link></li>
          </ul>
        </nav>
      </div>

      {isMenuOpen && isMobile && (
        <div 
          className="site-header__overlay active"
          onClick={handleOverlayClick}
        />
      )}
    </div>
  );
};

export default Header;
